module.exports = __webpack_public_path__ + "img/icon6.65e73a8d.png";